import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: number;
  active: number;
  total: number;
  icon: LucideIcon;
  color: string;
  bgColor: string;
  formatValue?: (value: number) => string;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  active,
  total,
  icon: Icon,
  color,
  bgColor,
  formatValue = (val) => val.toString()
}) => {
  const percentage = total > 0 ? Math.round((active / total) * 100) : 0;

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mt-1">
            {formatValue(value)}
          </p>
          <div className="flex items-center mt-2">
            <span className="text-sm text-green-600 font-medium">
              {formatValue(active)} hoạt động
            </span>
            <span className="text-sm text-gray-500 ml-2">
              ({percentage}%)
            </span>
          </div>
          {total !== value && (
            <div className="mt-1">
              <span className="text-xs text-gray-400">
                Tổng: {formatValue(total)}
              </span>
            </div>
          )}
        </div>
        <div className={`p-3 ${bgColor} rounded-lg`}>
          <Icon className={`h-8 w-8 ${color}`} />
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
